import Swiper from 'swiper'
import { Navigation, Pagination, EffectFade, EffectFlip, EffectCoverflow } from 'swiper/modules'
import DOMReady from '../utils/DOMReady'

// eslint-disable-next-line no-unused-vars
import css from '../../css/blocks/hero.scss'

class Hero {
  /**
   * Constructor
   *
   * @param {Element} el HTML element to replace with a vimeo iframe
   */
  constructor(el) {
    this.container = el
    this.swiper = this.container.querySelector('.swiper')
    this.pagination = this.container.querySelector('.hero__pagination')
    this.next = this.container.querySelector('.hero__button-next')
    this.prev = this.container.querySelector('.hero__button-prev')

    const { settings } = this.container.dataset
    this.settings = settings ? JSON.parse(settings) : {}
    this.settings.modules = []

    if (this.next && this.prev) {
      this.settings.modules.push(Navigation)
      this.settings.navigation = {
        nextEl: this.next,
        prevEl: this.prev,
      }
    }

    if (this.pagination) {
      this.settings.modules.push(Pagination)
      this.settings.pagination = {
        el: this.pagination,
        type: 'bullets',
        clickable: true,
        bulletElement: 'button',
      }
    }

    if (this.settings.effect === 'fade') {
      this.settings.modules.push(EffectFade)
      this.settings.crossFade = true
    }

    if (this.settings.effect === 'flip') {
      this.settings.modules.push(EffectFlip)
    }

    if (this.settings.effect === 'coverflow') {
      this.settings.modules.push(EffectCoverflow)
    }

    if (this.swiper) {
      this.slider = new Swiper(this.swiper, this.settings)
    }
  }
}

DOMReady(() => {
  const elements = document.querySelectorAll('.hero')
  if (elements !== null) {
    elements.forEach(element => new Hero(element))
  }
})
